module.exports = __webpack_public_path__ + "img/danamon-bdi.bd8b1a40.jpg";